<template>
  <div class="container p-8 mx-auto border border-t-0">
    <h2 class="mt-10 mb-4 text-lg font-semibold">Personal Information</h2>
    <!-- Form Fields for Recording Donation -->
    <form @submit.prevent="moveToNext">
      <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
        <div>
          <label class="block mb-2 font-medium text-gray-700" for="lastName">Last Name/Other Name <span
              class="text-red-500">*</span></label>
          <input id="lastName" type="text"
            class="w-full p-3 bg-gray-100 border rounded shadow-sm appearance-none placeholder-gray shadow-gray-400"
            placeholder="Enter Last Name/Other Name" v-model="localFormData.donorInformation.last_name" required />
        </div>

        <div>
          <label class="block mb-2 font-medium text-gray-700" for="firstName">First Name <span
              class="text-red-500">*</span></label>
          <input id="firstName" type="text"
            class="w-full p-3 bg-gray-100 border rounded shadow-sm appearance-none placeholder-gray shadow-gray-400"
            placeholder="Enter First Name" v-model="localFormData.donorInformation.first_name" required />
        </div>

        <div>
          <label class="block mb-2 font-medium text-gray-700" for="birthDate">Date of Birth <span
              class="text-red-500">*</span></label>
          <input type="date" id="birthDate"
            class="w-full p-3 bg-gray-100 border rounded shadow-sm appearance-none placeholder-gray shadow-gray-400"
            placeholder="select Date of Birth" v-model="localFormData.donorInformation.dob" @change="calculateAge"
            :max="maxDate" required />
        </div>

        <div>
          <label class="block mb-2 font-medium text-gray-700" for="gender">Gender <span
              class="text-red-500">*</span></label>
          <div class="relative">
            <select id="gender"
              class="w-full p-3 bg-gray-100 border rounded shadow-sm appearance-none placeholder-gray shadow-gray-400"
              v-model="localFormData.donorInformation.gender" required>
              <option value="" disabled selected>Select gender</option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
            </select>
            <div class="absolute inset-y-0 right-0 flex items-center px-2 text-gray-700 pointer-events-none">
              <svg class="w-4 h-4 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
              </svg>
            </div>
          </div>
        </div>

        <div>
          <label class="block mb-2 font-medium text-gray-700" for="idNum">ID. Number / Passport </label>
          <input id="idNum" type="text"
            class="w-full p-3 bg-gray-100 border rounded shadow-sm appearance-none placeholder-gray shadow-gray-400"
            placeholder="Enter ID. Number / Passport" v-model="localFormData.donorInformation.id_number" />
        </div>

        <div>
          <label class="block mb-2 font-medium text-gray-700" for="age">Age <span class="text-red-500">*</span></label>
          <input id="age" type="text"
            class="w-full p-3 bg-gray-100 border rounded shadow-sm appearance-none placeholder-gray shadow-gray-400"
            v-model="localFormData.donorInformation.age" readonly />
        </div>
      </div>

      <h2 v-if="hasNokDetailsTnh" class="mt-10 mb-4 text-lg font-semibold">Next of Kin</h2>
      <div v-if="hasNokDetailsTnh" class="grid grid-cols-1 gap-4 md:grid-cols-2">
        <div>
          <label class="block mb-2 font-medium text-gray-700" for="nokName">Next of Kin Names </label>
          <input id="nokName" type="text"
            class="w-full p-3 bg-gray-100 border rounded shadow-sm appearance-none placeholder-gray shadow-gray-400"
            placeholder="Enter First Name" v-model="localFormData.donorInformation.nok_names" />
        </div>

        <div>
          <label class="block mb-2 font-medium text-gray-700" for="nokPhone">Next of kin Phone </label>
          <input id="nokPhone" type="text"
            class="w-full p-3 bg-gray-100 border rounded shadow-sm appearance-none placeholder-gray shadow-gray-400"
            placeholder="Enter phone number" v-model="localFormData.donorInformation.nok_phone" />
        </div>

        <div>
          <label class="block mb-2 font-medium text-gray-700" for="nokRelationship">Relationship With Donor </label>
          <input id="nokRelationship" type="text"
            class="w-full p-3 bg-gray-100 border rounded shadow-sm appearance-none placeholder-gray shadow-gray-400"
            placeholder="Enter First Name" v-model="localFormData.donorInformation.nok_relationship" />
        </div>
      </div>

      <h2 class="mt-10 mb-4 text-lg font-semibold">Medical History</h2>
      <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
        <div>
          <label class="block mb-2 font-medium text-gray-700" for="donorStatus">Donor Status <span
              class="text-red-500">*</span></label>
          <div class="relative">
            <select id="donorStatus"
              class="w-full p-3 bg-gray-100 border rounded shadow-sm appearance-none placeholder-gray shadow-gray-400"
              v-model="localFormData.donorInformation.donor_status" required>
              <option value="" disabled selected>Select status</option>
              <option value="FirstTime">First Time</option>
              <option value="Repeat">Repeat</option>
              <option value="Regular">Regular</option>
            </select>
            <div class="absolute inset-y-0 right-0 flex items-center px-2 text-gray-700 pointer-events-none">
              <svg class="w-4 h-4 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
              </svg>
            </div>
          </div>
        </div>

        <div v-if="['Repeat', 'Regular',].includes(localFormData.donorInformation.donor_status)">
          <label class="block mb-1" for="lastDonation">Last Donation Date <span class="text-red-500">*</span></label>
          <input type="date" id="lastDonation"
            class="w-full p-3 bg-gray-100 border rounded shadow-sm appearance-none placeholder-gray shadow-gray-400"
            placeholder="select Last Donation Date" v-model="localFormData.donorInformation.last_donation_date"
            required />
        </div>

        <div>
          <label class="block mb-2 font-medium text-gray-700" for="donationType">Donation Type <span
              class="text-red-500">*</span></label>
          <div class="relative">
            <select id="donationType"
              class="w-full p-3 bg-gray-100 border rounded shadow-sm appearance-none placeholder-gray shadow-gray-400"
              v-model="localFormData.donorInformation.donation_status" required>
              <option value="" disabled selected>Select status</option>
              <option value="Replacement">
                Replacement (Replaces blood unit for specific patient)
              </option>
              <option value="Random">
                Random (First-time donor, not for specific patient)
              </option>
              <option value="Frequent">
                Regular-donor (Frequent donor, not for specific patient)
              </option>
              <option value="Designated">
                Designated/Directed (Donates for specific patient with doctor's
                letter)
              </option>
              <option value="Autologous">
                Autologous (Donates for future self use with doctor's letter)
              </option>
            </select>
            <div class="absolute inset-y-0 right-0 flex items-center px-2 text-gray-700 pointer-events-none">
              <svg class="w-4 h-4 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
              </svg>
            </div>
          </div>
        </div>

        <div
          v-if="['Replacement', 'Designated', 'Autologous'].includes(localFormData.donorInformation.donation_status)">
          <label class="block mb-2 font-medium text-gray-700" for="patientName">
            Patient Name
          </label>
          <input id="patientName" type="text"
            class="w-full p-3 bg-gray-100 border rounded shadow-sm appearance-none placeholder-gray shadow-gray-400"
            placeholder="Enter Patient Name" v-model="localFormData.donorInformation.patient" />
        </div>

        <div>
          <label class="block mb-2 font-medium text-gray-700" for="regularDonor">Would you like to become a regular
            blood donor?
            <span class="text-red-500">*</span></label>
          <div class="relative">
            <select id="regularDonor"
              class="w-full p-3 bg-gray-100 border rounded shadow-sm appearance-none placeholder-gray shadow-gray-400"
              v-model="localFormData.donorInformation.enroll_as_donor" required>
              <option value="" disabled selected>Select</option>
              <option value="true">Yes</option>
              <option value="false">No</option>
            </select>
            <div class="absolute inset-y-0 right-0 flex items-center px-2 text-gray-700 pointer-events-none">
              <svg class="w-4 h-4 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
              </svg>
            </div>
          </div>
        </div>

        <div
          v-if="['Replacement', 'Designated', 'Autologous'].includes(localFormData.donorInformation.donation_status)">
          <label class="block mb-2 font-medium text-gray-700" for="wardNum">Ward Number</label>
          <input id="wardNum" type="text"
            class="w-full p-3 bg-gray-100 border rounded shadow-sm appearance-none placeholder-gray shadow-gray-400"
            placeholder="Enter Ward Number" v-model="localFormData.donorInformation.ward" />
        </div>
      </div>

      <h2 class="mt-10 mb-4 text-lg font-semibold">Contact Information</h2>
      <div>
          <label class="block mb-1 text-sm italic text-gray-400" for="optional">Provide Either Phone number or Email or both</label>
      </div>
      <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
        <div>
          <label class="block mb-2 font-medium text-gray-700" for="phone">Phone Number</label>
          <input id="phone" type="text"
            class="w-full p-3 bg-gray-100 border rounded shadow-sm appearance-none placeholder-gray shadow-gray-400"
            placeholder="Enter phone number" v-model="localFormData.donorInformation.phone_number" />
        </div>

        <div>
          <label class="block mb-2 font-medium text-gray-700" for="email">Email</label>
          <input id="address" type="email"
            class="w-full p-3 bg-gray-100 border rounded shadow-sm appearance-none placeholder-gray shadow-gray-400"
            placeholder="Enter Email" v-model="localFormData.donorInformation.email" />
        </div>

        <div>
          <label class="block mb-2 font-medium text-gray-700" for="appointmentDate">Preferred appointment date (if donor
            is not in the donation
            center)
          </label>
          <input type="text" id="appointmentDate"
            class="w-full p-3 bg-gray-100 border rounded shadow-sm appearance-none placeholder-gray shadow-gray-400"
            placeholder="Select preferred date" onfocus="(this.type='date')"
            onblur="if(this.value===''){this.type='text'}" v-model="localFormData.donorInformation.preferred_date" />
        </div>

        <div>
          <label class="block mb-2 font-medium text-gray-700" for="appointmentTime">
            Preferred appointment time (if donor is not in the donation center)

          </label>
          <div class="relative">
            <select id="appointmentTime"
              class="w-full p-3 bg-gray-100 border rounded shadow-sm appearance-none placeholder-gray shadow-gray-400"
              v-model="localFormData.donorInformation.preferred_time"
              :disabled="!localFormData.donorInformation.preferred_date">
              >
              <option disabled value="">Select preferred time</option>
              <option v-for="time in predefinedTimeSlots" :key="time" :value="time">{{ time }}</option>
            </select>
            <div class="absolute inset-y-0 right-0 flex items-center px-2 text-gray-700 pointer-events-none">
              <svg class="w-4 h-4 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                <path
                  d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" />
              </svg>
            </div>
          </div>
        </div>



        <div>
          <label class="block mb-2 font-medium text-gray-700" for="address">Postal Address </label>
          <input id="address" type="text"
            class="w-full p-3 bg-gray-100 border rounded shadow-sm appearance-none placeholder-gray shadow-gray-400"
            placeholder="Enter Postal Address" v-model="localFormData.donorInformation.physical_address" />
        </div>

        <div>
          <label class="block mb-2 font-medium text-gray-700" for="county"> County of birth <span
              class="text-red-500">*</span></label>
          <div class="relative">
            <select id="county_id" v-model="localFormData.donorInformation.county_id"
              class="w-full p-3 bg-gray-100 border rounded shadow-sm appearance-none placeholder-gray shadow-gray-400"
              required>
              <option value="" disabled>Select county</option>
              <option v-for="county in counties" :key="county.county_id" :value="county.county_id">
                {{ county.name }}
              </option>
            </select>
            <div class="absolute inset-y-0 right-0 flex items-center px-2 text-gray-700 pointer-events-none">
              <svg class="w-4 h-4 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                <path
                  d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" />
              </svg>
            </div>
          </div>
        </div>

        <div>
          <label class="block mb-2 font-medium text-gray-700" for="tcs">Select whether user has agreed with T&Cs <span
              class="text-red-500">*</span></label>
          <select id="tcs" v-model="localFormData.donorInformation.terms_agreed"
            class="w-full p-3 bg-gray-100 border rounded shadow-sm appearance-none placeholder-gray shadow-gray-400"
            required>
            <option value="" disabled>Select whether user has agreed with T&Cs</option>
            <option value="Yes">Yes</option>
            <option value="No">No</option>
          </select>
        </div>

      </div>

      <div class="flex justify-between mt-8">
        <button type="button" class="px-4 py-2 text-orange-500 border border-orange-500 rounded"
          @click="moveToPrevious">
          Back
        </button>
        <CustomButton type="submit" label="next" class="px-4 py-2" bg-class="bg-custom-yellow" />
      </div>
    </form>
  </div>
</template>

<script>
import CustomButton from "@/components/CustomButton.vue";
import api from '@/services/api';
import SweetAlertService from '@/services/SweetAlertService';

export default {
  name: "NewDonorInformationForm",
  components: {
    CustomButton,
  },
  data() {
    return {
      localFormData: { ...this.formData },
      maxDate: this.calculateMaxDate(),
      counties: [],
      flags: [],
      hasNokDetailsTnh: false,
      predefinedTimeSlots: this.generatePredefinedTimeSlots(),
    };
  },

  created() {
    this.maxDate = this.calculateMaxDate();
    this.fetchRegions();
  },

  watch: {
    'localFormData.donorInformation.dob': 'calculateAge',
    localFormData: {
      handler(newValue) {
        this.$emit('update:formData', newValue);
      },
      deep: true,
    },
  },

  mounted() {
    this.flags = this.$store.getters["auth/flags"];
    this.hasNokDetailsTnh = this.flags.some(flag => flag === "TNH Next of Kin Details");
  },

  props: {
    formData: Object
  },

  methods: {
    checkEmptyFields() {
      const emptyFields = [];

      // Check for required donor information fields
      const donorInformation = this.localFormData.donorInformation;

      if (!donorInformation.first_name || donorInformation.first_name === '') {
        emptyFields.push(this.getFieldLabel('first_name'));
      }

      // Phone or email (at least one required)
      if (!donorInformation.phone_number && !donorInformation.email) {
        emptyFields.push('Phone Number or Email');
      }

      return emptyFields;
    },

    getFieldLabel(key) {
      const labels = {
        first_name: 'First Name',

      };
      return labels[key] || key;
    },

    calculateMaxDate() {
      const today = new Date();
      const year = today.getFullYear() - 16;
      const month = today.getMonth() + 1;
      const day = today.getDate();
      return `${year}-${month < 10 ? "0" : ""}${month}-${day < 10 ? "0" : ""}${day}`;
    },

    calculateAge() {
      const dob = this.localFormData.donorInformation.dob;
      if (!dob) {
        this.localFormData.donorInformation.age = "";
        return;
      }
      const today = new Date();
      const birthDate = new Date(dob);
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDifference = today.getMonth() - birthDate.getMonth();

      if (
        monthDifference < 0 ||
        (monthDifference === 0 && today.getDate() < birthDate.getDate())
      ) {
        age--;
      }
      this.localFormData.donorInformation.age = age;
    },

    generatePredefinedTimeSlots() {
      const slots = [];
      let startTime = new Date();
      startTime.setHours(8, 0, 0); // Set start time to 08:00 AM
      const endTime = new Date();
      endTime.setHours(17, 0, 0); // Set end time to 05:00 PM

      while (startTime < endTime) {
        const formattedTime = startTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
        slots.push(formattedTime);
        startTime.setMinutes(startTime.getMinutes() + 30); // Add 30 minutes for each slot
      }

      return slots;
    },

    async validateBookingSlot() {
      const preferredTime = this.localFormData.donorInformation.preferred_time;
      // Check if preferred time is within predefined slots
      if (!this.predefinedTimeSlots.includes(preferredTime)) {
        SweetAlertService.showWarning('Invalid Time Slot', `The time slot ${preferredTime} is not valid. Please select a time between 8 AM and 5 PM.`);
        return false;
      }

      try {
        const response = await api.validateBookingSlot({
          preferred_date: this.localFormData.donorInformation.preferred_date,
          preferred_time: preferredTime,
        });

        if (response.available) {
          return true;
        } else {
          SweetAlertService.showWarning('Slot Unavailable', 'The selected date and time are not available. Please choose a different slot.');
          return false;
        }
      } catch (error) {
        SweetAlertService.showError('Validation Error', 'There was an error validating the booking slot. Please try again.');
        return false;
      }
    },

    async fetchRegions() {
      try {
        const response = await api.getRegions();
        const kenyaRegion = response.regions.find((region) => region.name === 'Kenya');
        this.counties = kenyaRegion ? kenyaRegion.counties : [];
      } catch (error) {
        console.error("Error fetching regions:", error);
      }
    },

    async moveToNext() {
      // Check if any fields are empty
      const emptyFields = this.checkEmptyFields();
      if (emptyFields.length > 0) {
        await SweetAlertService.showEmptyFieldsAlert(emptyFields);
        return;
      }

      // Check if both preferred date and time are filled before validating the slot
      const preferredDate = this.localFormData.donorInformation.preferred_date;
      const preferredTime = this.localFormData.donorInformation.preferred_time;
      if (preferredDate && preferredTime) {
        const isSlotAvailable = await this.validateBookingSlot();

        if (!isSlotAvailable) {
          return; // Stop the process if the slot is unavailable
        }
      }

      // Proceed to the next step if either slot validation passed or date/time is not filled
      this.$emit("move-to-next-step");
    },

    moveToPrevious() {
      this.$emit("move-to-previous-step");
    },
  },
};
</script>
